import api from "./api";

const URL_PREFIX = '/files/';

class FilesService {
  getAnalysisId(customer_id = '') {
    const params = { customer_id };
    return api.get(URL_PREFIX + "getAnalysisId", { params });
  }

  getUser() {
    return api.get(URL_PREFIX + "getUser");
  }

  uploadEdicto(data) {
    return api.post(URL_PREFIX + "upload-edicto",
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        isMultipart: true
      }
    );
  }

  uploadCargas(data) {
    return api.post(URL_PREFIX + "upload-cargas",
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        isMultipart: true
      }
    );
  }

  useCredit(analysisId) {
    return api.post(URL_PREFIX + "use-credit", { analysisId });
  }

  getAnalysis(analysisId) {
    return api.get(`${URL_PREFIX}get-analysis`, { params: { analysisId } });
  }

  getAnalysisStatus(analysisId) {
    return api.get(`${URL_PREFIX}get-analysis-status`, { params: { analysisId } });
  }

  startWithId(subastaId) {
    return api.get(`${URL_PREFIX}get-subasta`, { params: { subastaId } });
  }

}

const filesServiceInstance = new FilesService();

export default filesServiceInstance;